
/**
 * route - the rect router dom route
 * mainMenu - MOBILE => if its on the nav bar
 * loggedIn - if the user needs to be logged in to see this route
 * iconOnly - if it only shows the route
 * adminOnly - admin only route
 */
export default [
    {
        route: "/",
        name: "home",
        icon: "fas fa-home",
        mainMenu:true,
        loggedIn:false,
        // iconOnly:true,
    },
    // {
    //     route: "/about",
    //     name: "about",
    //     icon: "fas fa-info-circle",
    //     mainMenu:true,
    //     loggedIn:false,
    //     iconOnly:false,
    // },
    {
        route: "/service",
        name: "service",
        icon: "fas fa-server",
        mainMenu:true,
        loggedIn:false,
        iconOnly:false,
    },
    {
        route: "/consortium",
        name: "consortium",
        icon: "fas fa-users",
        mainMenu:true,
        loggedIn:false,
        iconOnly:false,
    },
    {
        route: "/production-baseline",
        name: "Production Baseline",
        icon: "fas fa-satellite",
        mainMenu: true,
        loggedIn: false,
        adminOnly:false,
        iconOnly: false,
    },
    {
        route: "/kpi",
        name: "KPI",
        icon: "fas fa-chart-line",
        mainMenu:true,
        loggedIn:true,
        // adminOnly:true,
        iconOnly:false,
    },
    {
        name: "utils",
        icon: "fas fa-tools",
        mainMenu:true,
        loggedIn:true,
        // adminOnly:true,
        iconOnly:false,
        subMenu:[
            {
                href:'https://acricwe.sharepoint.com/sites/S3PS/Lists/Action%20tracking/AllItems.aspx',
                name: "Actions Tracking",
                icon: "fas fa-clipboard-list",
            },
            {
                // route: "/utils/documents",
                href:'https://acricwe.sharepoint.com/sites/S3PS/Shared%20Documents/Forms/AllItems.aspx',
                name: "Documents",
                icon: "fas fa-file",
            },
        ]
    },
    {
        route: "/admin",
        name: "admin",
        icon: "fas fa-user-shield",
        mainMenu:true,
        loggedIn:true,
        adminOnly:true,
        iconOnly:false,
    },
]